import { NgModule } from '@angular/core';
import { CreditCardNumberPipe } from './credit-card-number-pipe';
import { ContentAssetImagePipe } from './content-asset-image-pipe';
import { ContentImagePipe } from './content-image-pipe';
import { MarkdownTranslatePipe } from './markdown-translate-pipe';
import { SafeHtmlPipe } from './safe-html-pipe';
import { FortressCurrencyPipe } from './fortress-currency.pipe';
import { WithLoadingPipe } from './with-loading.pipe';
import { LongtoShortTextPipe } from './long-to-short-text-pipe';
import { ContentLanguageFilterPipe } from './current-language-content-pipe';
import { UtcToLocaltimePipe } from './utc-to-local.pipe';
import { TruncatePipe } from './truncate.pipe';
import { LeaderboardInitialsPipe } from './leaderboard-initials.pipe';
import { LeaderBoardTopPositionsPipe } from './leaderboard-position.pipe';

@NgModule({
  declarations: [
    ContentAssetImagePipe,
    ContentImagePipe,
    SafeHtmlPipe,
    CreditCardNumberPipe,
    MarkdownTranslatePipe,
    FortressCurrencyPipe,
    WithLoadingPipe,
    LongtoShortTextPipe,
    ContentLanguageFilterPipe,
    UtcToLocaltimePipe,
    TruncatePipe,
    LeaderboardInitialsPipe,
    LeaderBoardTopPositionsPipe,
  ],
  exports: [
    ContentAssetImagePipe,
    ContentImagePipe,
    SafeHtmlPipe,
    CreditCardNumberPipe,
    MarkdownTranslatePipe,
    FortressCurrencyPipe,
    WithLoadingPipe,
    LongtoShortTextPipe,
    ContentLanguageFilterPipe,
    UtcToLocaltimePipe,
    TruncatePipe,
    LeaderboardInitialsPipe,
    LeaderBoardTopPositionsPipe,
  ],
  imports: [],
})
export class PipesModule {}
